import axios from 'axios';
import instance from '@/axios';
import { enterprise, financeData } from '@/axios/interface';

const cancelSourceMap = new Map();
cancelSourceMap.set('customs_calendar_schedule', null);

const openCancelSource = key => {
	let cancelSource = cancelSourceMap.get(key);
	if (cancelSource) {
		cancelSource.cancel('取消请求: ' + key);
	}
	cancelSource = axios.CancelToken.source();
	cancelSourceMap.set(key, cancelSource);
	return cancelSource;
};

export const defaultVersion = 'v1';

export const loaderFactories = {
	news:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.news(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	news_detail:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.newsDetail(ctx.storeId, params.id), {
				...params,
				languageType: ctx.languageType
			});
		},

	quarterlyPerformance:
		ctx =>
		(params = {}) => {
			const { storeId = ctx.storeId, ...restParams } = params;
			return instance.get(enterprise.getQuarterPerformance(storeId), {
				...restParams,
				languageType: ctx.languageType
			});
		},
	//获取主要财务指标
	quarterlyPerformance_financialStatement:
		ctx =>
		(params = {}) => {
			const { fullCode = ctx.fullCode, ...restParams } = params;
			return instance.get(enterprise.getFinancialStatement(fullCode), {
				...restParams
			});
		},
	//利润表
	quarterlyPerformance_profitStatement:
		ctx =>
		(params = {}) => {
			const { fullCode = ctx.fullCode, ...restParams } = params;
			return instance.get(enterprise.getProfitStatement(fullCode), {
				...restParams
			});
		},
	//资产负债表
	quarterlyPerformance_balanceSheet:
		ctx =>
		(params = {}) => {
			const { fullCode = ctx.fullCode, ...restParams } = params;
			return instance.get(enterprise.getBalanceSheet(fullCode), {
				...restParams
			});
		},
	//现金流量表
	quarterlyPerformance_cashFlowStatement:
		ctx =>
		(params = {}) => {
			const { fullCode = ctx.fullCode, ...restParams } = params;
			return instance.get(enterprise.getCashFlowStatement(fullCode), {
				...restParams
			});
		},
	quote:
		ctx =>
		(params = {}) => {
			let market = ctx.market,
				code = ctx.code;
			if (params.market) market = params.market;
			if (params.code) code = params.code;
			const requestParams = {};
			// realType 1=实时数据，支持每分钟查询
			if (params.realType !== undefined) {
				requestParams.realType = params.realType;
			}
			return instance.get(enterprise.getStockQuote(market, code), {
				...requestParams
			});
		},

	quote_quoteKLine:
		ctx =>
		(params = {}) => {
			let fullCode = ctx.fullCode;
			if (params.fullCode) fullCode = params.fullCode;
			return instance.get(enterprise.getKLineData(fullCode, params.defaultTime), {
				startTradingDay: params.startTradingDay,
				endTradingDay: params.endTradingDay
			});
		},
	quote_quoteRealTimeStockQuotation:
		ctx =>
		(params = {}) => {
			// 上交所数据, 接入后才支持查询，支持每秒查询
			return instance.post(enterprise.queryRealTimeStockQuotation, {
				fullCode: ctx.code,
				types: ['line', 'snapPro'],
				...params
			});
		},
	//分红送配
	quote_stockDividendPlan:
		ctx =>
		(params = {}) => {
			if (params.fullCode) {
				const { fullCode, ...restParams } = params;
				return instance.get(enterprise.getStockDividendPlan(fullCode), {
					...restParams
				});
			}
			return instance.get(enterprise.getStockDividendPlan(ctx.fullCode), {
				...params
			});
		},

	//融资融券
	quote_stockMarginFunds:
		ctx =>
		(params = {}) => {
			if (params.fullCode) {
				const { fullCode, ...restParams } = params;
				return instance.get(enterprise.getStockMarginFunds(fullCode), {
					...restParams
				});
			}
			return instance.get(enterprise.getStockMarginFunds(ctx.fullCode), {
				...params
			});
		},
	//北向南资金
	quote_stockNorthSouthFunds:
		ctx =>
		(params = {}) => {
			if (params.fullCode) {
				const { fullCode, ...restParams } = params;
				return instance.get(enterprise.getStockNorthSouthFunds(fullCode), {
					...restParams
				});
			}
			return instance.get(enterprise.getStockNorthSouthFunds(ctx.fullCode), {
				...params
			});
		},
	question:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getAdvisoryList, {
				...params,
				fullCode: ctx.fullCode,
				storeId: ctx.storeId,
				languageType: ctx.languageType
			});
		},
	question_detail:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.questionDetail(ctx.storeId, params.uniqueCode, params.sourceBiz), {
				languageType: ctx.languageType
			});
		},
	leave_word_create:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.createLeaveWord(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	leave_word_config:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getLeaveWordConfig(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	message_subscription_institutionList:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.allInstitutionList, {
				...params
			});
		},
	message_subscription_messageMailCode:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getMessageMailCode(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	message_subscription_create:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.createMessageContact(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	message_event:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getMessageEvent(ctx.storeId), {
				languageType: ctx.languageType
			});
		},
	cancel_email:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.cancelEmail(ctx.storeId), {
				...params
			});
		},
	message_contact_config:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getMessageContactConfigV2(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	// 投关活动
	investment_activity:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.postAllActivityList(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},
	investment_activity_recently:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getRecentlyList(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},
	roadshow:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getRoadshowList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},
	offline:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getActivityList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},
	research:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getSurveyList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},
	analyst:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getAnalystDataSide(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true
			});
		},
	announcement:
		ctx =>
		(params = {}) => {
			if (params.fullCode) {
				return instance.get(enterprise.getAnnouncementsByStock(params.fullCode), {
					...params,
					isPublish: true,
					languageType: typeof params.languageType === 'number' ? params.languageType : ctx.languageType
				});
			}
			// 根据不同模板类型选择不同的API
			if (params.useStockCode) {
				// 使用股票代码的API (flow模板)
				return instance.get(enterprise.getAnnouncementsByStock(ctx.fullCode), {
					...params,
					isPublish: true,
					languageType: typeof params.languageType === 'number' ? params.languageType : ctx.languageType
				});
			} else {
				// 使用storeId的API (flowX简览，slide模板)
				return instance.get(enterprise.getAnnouncements(ctx.storeId), {
					...params,
					isPublish: true,
					languageType: typeof params.languageType === 'number' ? params.languageType : ctx.languageType
				});
			}
		},
	report:
		ctx =>
		(params = {}) => {
			if (params.fullCode) {
				return instance.post(enterprise.reportList, {
					...params,
					fullCode: params.fullCode,
					languageType: typeof params.languageType === 'number' ? params.languageType : ctx.languageType
				});
			}
			return instance.post(enterprise.reportList, {
				fullCode: ctx.fullCode,
				languageType: ctx.languageType,
				...params
			});
		},

	customs_calendar_recently:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getScheduleRecentlyMonth(ctx.storeId));
		},
	customs_calendar:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.getScheduleLatestThree(ctx.storeId), {
				pageNum: 0,
				pageSize: 3,
				languageType: ctx.languageType,
				...params
			});
		},
	customs_calendar_schedule:
		ctx =>
		(params = {}) => {
			// 开启重复请求取消
			const cancelSource = openCancelSource('customs_calendar_schedule');
			return instance.post(
				enterprise.apiPostScheduleList(ctx.storeId),
				{
					languageType: ctx.languageType,
					...params
				},
				undefined,
				cancelSource.token
			);
		},
	customs_calendar_list:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.apiGetIrstoreCalendarList(ctx.storeId), {
				...params
			});
		},
	// ESG数据获取
	esg:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getESGData(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		},
	// ESG报告获取
	esg_report:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getCustomModuleContent(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 股东人数
	shareholder_count:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getShareholderList(ctx.market, ctx.code), {
				...params
			});
		},

	// 基金持股 - 概览数据
	fund_holding:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getStockFundHolding(ctx.fullCode), {
				...params
			});
		},

	// 基金持股 - 分页数据
	fund_holding_page:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getStockFundHoldingPage(ctx.fullCode), {
				...params
			});
		},

	// 基金持股 - 图表数据
	fund_holding_chart:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getStockFundHoldingBarChart(ctx.fullCode), {
				...params
			});
		},

	// 十大股东 - 持股数据
	top_ten_shareholder:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getTopTenHoldings(ctx.market, ctx.code), {
				...params
			});
		},

	// 十大股东 - 日期列表
	top_ten_shareholder_dates:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getTopTenHoldingsDate(ctx.market, ctx.code), {
				...params
			});
		},

	// 美股公告
	us_announcement:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getUsAnnouncements(ctx.storeId), {
				...params
			});
		},
	us_announcement_type:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getUsAnnouncementType(ctx.storeId), {
				...params
			});
		},

	// 分红计划 - 汇总数据
	dividend_plan_summary:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getDividendsSummary(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 分红计划 - 年度图表数据
	dividend_plan_chart:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getStockYearDividend(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 分红计划 - 表格数据
	dividend_plan_table:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getStockDividendPlan(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 财务数据 - 主要指标
	main_index:
		ctx =>
		(params = {}) => {
			return instance.get(financeData.getMain(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 财务数据 - 资产负债表
	balance_sheet:
		ctx =>
		(params = {}) => {
			return instance.get(financeData.getLiabilities(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 财务数据 - 利润表
	profit_statement:
		ctx =>
		(params = {}) => {
			return instance.get(financeData.getProfit(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 财务数据 - 现金流量表
	cash_flow_statement:
		ctx =>
		(params = {}) => {
			return instance.get(financeData.getCash(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 企业管治 - 主要数据
	corporate_governance:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getCorporateData(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},

	// 企业管治 - 详情数据
	corporate_governance_details:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getCorporateDetails(ctx.storeId, params.businessId), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 企业管治 - 自定义模块内容（管治文件）
	corporate_governance_custom:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getCustomModuleContent(ctx.storeId), {
				languageType: ctx.languageType,
				pageStart: 0,
				pageNum: 1000,
				...params
			});
		},

	// 自定义模块
	custom:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.getCustomModuleContent(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 研报详情
	report_detail:
		ctx =>
		(params = {}) => {
			return instance.post(enterprise.researchReportDetail(), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 主营业务
	main_business:
		ctx =>
		(params = {}) => {
			return instance.get(enterprise.mainBusiness(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		}
};
